export default {
      'MASTER-PRODUCT-MANAGEMENT': {
        key: 'master-product-managment',
        label: 'master-商品条码管理-点击'
      },
      'MASTER-PRODUCT-ZONECONTRAST': {
        key: 'master-product-zoneContrast',
        label: 'master-储位对照-点击'
      },
      'MASTER-PRODUCT-BATCH-ZONECONTRAST': {
        key: 'master-product-batch-zoneContrast',
        label: 'master-批量储位对照-点击'
      },
      'MASTER-PRODUCT-SERIALNUMBER': {
        key: 'master-product-serialNumber',
        label: 'master-商品序列号维护-点击'
      },
      'MASTER-PRODUCT-BATCH-ATTRIBUTE': {
        key: 'master-product-batchAttribute',
        label: 'master-批属性管理-点击'
      },
      'MASTER-PRODUCT-EXTENSION-ATTRIBUTE': {
        key: 'master-product-extensionAttribute',
        label: 'master-商品扩展属性管理-点击'
      },
      'MASTER-PRODUCT-FILLRATE': {
        key: 'master-product-fillRate',
        label: 'master-商品填充率-点击'
      },
      'MASTER-PRODUCT-SAFE-STOCKIMPORT': {
        key: 'master-product-safe-stockImport',
        label: 'master-安全库存导入-点击'
      },
      'MASTER-PRODUCT-SKU-STANDARDIMPORT': {
        key: 'master-product-sku-standardImport',
        label: 'master-sku打托标准导入-点击'
      }
}